import store from '@/store'

export default new class CompanyService {
    setup() {
        // this.__defineGetter__
    }

    getField(field) {
        return store.getters['company/'+field]
    }
}